// extracted by mini-css-extract-plugin
export var alignCenter = "_bl-d";
export var bannerShown = "_bl-6";
export var buttonContent = "_bl-0";
export var cardList = "_bl-1";
export var centerContent = "_bl-2";
export var chevron = "_bl-3";
export var closePanelButton = "_bl-k";
export var conversationContextContainer = "_bl-l";
export var conversationDetailContainer = "_bl-4";
export var detailWrapper = "_bl-7";
export var dropdownButton = "_bl-e";
export var dropdownTitle = "_bl-9";
export var fullHeight = "_bl-5";
export var hidden = "_bl-a";
export var icon = "_bl-b";
export var mergeSuggestionWrapper = "_bl-m";
export var panel = "_bl-i";
export var portalButtonsWrapper = "_bl-c";
export var right = "_bl-j";
export var tableSummaryContainer = "_bl-8";
export var tableSummaryHeader = "_bl-g";
export var threeDotsButton = "_bl-f";
export var wide = "_bl-h";